import { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import { getBankBalances } from "../../../services/tenantUserAdminService";
import { TC } from "../../../tokens/text";
import { useHistory } from "react-router-dom";

export default function BankBalancesWidget({ tenantId }) {
  const [loading, setLoading] = useState(true);
  const [balances, setBalances] = useState([]);
  const history = useHistory();

  useEffect(() => {
    const demoMode = typeof window !== 'undefined' && (window.__LEDGERHUB_DEMO || new URLSearchParams(window.location.search).get('demo') === 'true');
    if (demoMode) {
      setBalances([
        { accountId: "demo-1", accountName: "Demo Current Account", currentBalance: 12500 },
        { accountId: "demo-2", accountName: "Demo Savings", currentBalance: 8400 },
      ]);
      setLoading(false);
      return;
    }
    if (!tenantId) return;
    setLoading(true);
    getBankBalances(tenantId)
      .then((res) => setBalances(res.balances || []))
      .catch(() => setBalances([]))
      .finally(() => setLoading(false));
  }, [tenantId]);

  if (loading) return (
    <VuiBox display="flex" justifyContent="center" alignItems="center" height="100%"><CircularProgress size={24} /></VuiBox>
  );

  if (!balances.length) return (
    <VuiBox p={2}><VuiTypography color="text">No linked accounts</VuiTypography></VuiBox>
  );

  const total = balances.reduce((s, b) => s + (Number(b.currentBalance) || 0), 0);

  return (
    <VuiBox p={1} display="flex" flexDirection="column" gap={1}>
      <VuiBox display="flex" justifyContent="space-between" alignItems="center">
        <VuiTypography sx={{ color: TC.secondary }}>Bank Balances</VuiTypography>
        <VuiTypography sx={{ color: TC.primary, fontWeight: 700 }}>£{total.toLocaleString()}</VuiTypography>
      </VuiBox>
      {balances.map((b) => (
        <VuiBox key={b.accountId} display="flex" justifyContent="space-between" sx={{ p: 1, background: "#f4f8ff", borderRadius: 1, cursor: 'pointer' }}
          role="button" tabIndex={0} onClick={() => history.push('/bank-feeds') } onKeyDown={(e) => e.key === 'Enter' && history.push('/bank-feeds')}>
          <VuiTypography sx={{ color: TC.primary }}>{b.accountName}</VuiTypography>
          <VuiTypography sx={{ color: TC.primary, fontWeight: 700 }}>£{(b.currentBalance || 0).toLocaleString()}</VuiTypography>
        </VuiBox>
      ))}
    </VuiBox>
  );
}

